<script>

    import Component from '../../components/pagesbuilder/dynamic-components/Component.vue';
    import PreviewNodeState from "../mixins/PreviewNodeState";
    import PreviewVisibilityMixin from "@/author/pagesbuilder/mixins/PreviewVisibilityMixin";
    export default {
        mixins : [PreviewVisibilityMixin, PreviewNodeState,Component],
        methods: {
            componentContextBindingFinished () {
                this.acquireComponentData();
                this.componentCreationCallback();
                this.checkAnimationTrigger();
                if (this.checkVisibility) {
                    this.checkVisibility();
                }
            },
        }
    }
</script>
